import { IonInput, IonLabel, IonText } from '@ionic/react';
import React from 'react';

type IonInputProps = typeof IonInput.defaultProps;

interface InputFieldProps {
  hasError?: boolean;
}

export type Props = InputFieldProps & IonInputProps;

const InputField = ({
  label,
  hasError,
  onIonChange,
  labelPlacement = 'floating',
  required = false,
  id,
  ...rest
}: Props) => (
  <IonInput
    aria-label={id}
    label={!required && labelPlacement !== 'floating' ? label : undefined}
    onIonInput={onIonChange}
    labelPlacement={labelPlacement}
    {...rest}
  >
    {label && labelPlacement === 'floating' && (
      <div slot="label">
        <IonText color={hasError ? 'danger' : undefined}>{label}</IonText>
      </div>
    )}
    {label && required && (
      <div slot="label">
        <IonLabel aria-labelledby={id} color={hasError ? 'danger' : undefined} position="fixed">
          {label} <IonText color={hasError ? 'danger' : 'primary'}>*</IonText>
        </IonLabel>
      </div>
    )}
  </IonInput>
);

export default InputField;
